export enum NoName {
	ROOM = 'Pokój',
	STUDIO = 'Studio',
}

export const NoNames: string[] = [NoName.ROOM, NoName.STUDIO];
